import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyChZau6-gxNkeSQ8KC2_wZzDV08e1bRnqc",
  authDomain: "test-draft-duke.firebaseapp.com",
  databaseURL:
    "https://test-draft-duke-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "test-draft-duke",
  storageBucket: "test-draft-duke.firebasestorage.app",
  messagingSenderId: "84296291061",
  appId: "1:84296291061:web:675d3fb568ec2149f6ebbc",
  measurementId: "G-CNJ47ZL1JE",
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export default app;
